import React, { useRef } from "react";
import "./ViewAreaSurveyReport.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const ViewAreaSurveyReport = () => {
  const componentRef = useRef();

  const data = {
    name: "Amit",
    panNumber: "WEHJEF21746EF",
    aadharNumber: "7643282186234",
    title: "DR.",
    gender: "Male",
    dob: "04/05/1990",
    fullName: "Amit Sharma",
    parent: "XYZ",
    mobile: "8973428893",
    email: "amit@gmail.com",
    pin: "934287",
    postOffice: "Ahiyapur",
    bankAccount: "248921349786342",
    ifsc: "SBIN098479043",
    bankBranch: "Muzaffarpur",
    bankName: "SBI",
    subDistrict: "Zero Mile",
    district: "Muzaffarpur",
    state: "Bihar",
    country: "India",
    cAddress: "Ahiyapur",
    pcAddress: "Zero mile, Ahiyapur, Muzaffarpur-822001",
    marital: "Married",
    doj: "12/06/2022",
    address: "Ahiyapur, Muzaffarpur-822001",
    cin: "UIR3486375538",
    contact: "9832423734",
    domain: "https://techvision.com",
    logoUrl: "/logo192.png",
  };

// // PDF Generator WITH MARGINS
// const generatePDF = async () => {
//   const input = componentRef.current;
//   if (!input) return;

//   const canvas = await html2canvas(input, {
//     scale: 2,
//     useCORS: true,
//     backgroundColor: "#fff",
//   });

//   const imgData = canvas.toDataURL("image/png");

//   const pdf = new jsPDF("p", "mm", "a4");

//   const pageWidth = pdf.internal.pageSize.getWidth();
//   const pageHeight = pdf.internal.pageSize.getHeight();

//   const margin = 10; // ⭐ Margin on all sides (mm)
//   const usableWidth = pageWidth - margin * 2;

//   const imgHeight = (canvas.height * usableWidth) / canvas.width;

//   let position = margin;
//   let heightLeft = imgHeight;

//   // First Page
//   pdf.addImage(imgData, "PNG", margin, position, usableWidth, imgHeight);
//   heightLeft -= pageHeight - margin * 2;

//   // Additional pages if content is long
//   while (heightLeft > 0) {
//     pdf.addPage();
//     position = margin - (imgHeight - heightLeft);
//     pdf.addImage(imgData, "PNG", margin, position, usableWidth, imgHeight);
//     heightLeft -= pageHeight - margin * 2;
//   }

//   pdf.save("AreaSurveyReport.pdf");
// };


 const tableKey = [
  {label: "Branch",value: "Test"},
  {label: "Survey Start Date",value: "Test"},
  {label: "Employee",value: "Test"},
  {label: "Area Name",value: "Test"},
  {label: "Village Name",value: "Test"},
  {label: "Population of Village",value: "Test"},
  {label: "Political Situation",value: "Test"},
  {label: "Law & Order Situation",value: "Test"},
  {label: "Distance from Branch (km)",value: "Test"},
  {label: "No. of Centers Possible",value: "Test"},
  {label: "No. of MFI Working",value: "Test"},
  {label: "Name of MFI",value: "Test"},
  {label: "Major Operation",value: "Test"},
  {label: "Road Status",value: "Test"},
];

 const relegionTable = [
  {label: "Hindu",value: "Test"},
  {label: "Muslim",value: "Test"},
  {label: "Sikh",value: "Test"},
  {label: "Christian",value: "Test"},
  {label: "Other",value: "Test"},
];

 const casteTable = [
  {label: "General",value: "Test"},
  {label: "OBC",value: "Test"},
  {label: "SC",value: "Test"},
  {label: "ST",value: "Test"},
  {label: "Other",value: "Test"},
];

  return (
    <div>
      <div className="area-survey-page-container" ref={componentRef}>

        {/* ---- HEADER ---- */}
        <div className="area-survey-page-top-header">
          <div className="area-survey-page-top-header-left">
            <img src={data.logoUrl} alt="logo" />
          </div>

          <div className="area-survey-page-top-header-right">
            <h2>{data.name || "Techvision"}</h2>
            <p><b>Address:</b> {data.address}</p>
            <p><b>CIN:</b> {data.cin}</p>
            <p><b>Mobile:</b> {data.contact}</p>
            <p><b>Email:</b> {data.email}</p>
            <p><b>Website:</b> {data.domain}</p>
          </div>
        </div>

        {/* ---- TITLE ---- */}
        <h2 className="area-survey-page-title">Area Survey Report</h2>

        {/* ---- TABLE ---- */}
        <div className="area-survey-page-table-wrapper">
        <table className="area-survey-page-table">
          <tbody>
            {
              tableKey?.map((data,index)=>(
                <tr key={index}>
              <th>{data?.label||"N/A"}</th>
              <td>{data?.value||"N/A"}</td>
            </tr>
              ))
            }
          </tbody>
        </table>
        <div className="area-survey-page-religion-caste-container">
          <div className="area-survey-page-religion">
            <h2>Religion in Percentage (%)</h2>
            <div className="area-survey-page-table-wrapper">
        <table className="area-survey-page-table">
          <tbody>
            {
              relegionTable?.map((data,index)=>(
                <tr key={index}>
              <th>{data?.label||"N/A"}</th>
              <td>{data?.value||"N/A"}</td>
            </tr>
              ))
            }
          </tbody>
        </table>
        </div>
          </div>
          <div className="area-survey-page-caste">
             <h2>Caste in Percentage (%)</h2>
            <div className="area-survey-page-table-wrapper">
        <table className="area-survey-page-table">
          <tbody>
            {
              casteTable?.map((data,index)=>(
                <tr key={index}>
              <th>{data?.label||"N/A"}</th>
              <td>{data?.value||"N/A"}</td>
            </tr>
              ))
            }
          </tbody>
        </table>
        </div>
          </div>
        </div>
        </div>
      </div>

      {/* ---- BUTTON ---- */}
      <div className="area-survey-page-print-btn-div">
        <button className="area-survey-page-print-btn" /*onClick={generatePDF}*/>
          Verify
        </button>
      </div>
    </div>
  );
};

export default ViewAreaSurveyReport;
